<template>
  <div class="article-list-view">
    <div class="container">
      <ArticleList />
    </div>
  </div>
</template>

<script>
  import ArticleList from "@/components/articles/ArticleList.vue";

  export default {
    name: "ArticleListView",
    components: {
      ArticleList,
    },
    data() {
      return {};
    },
  };
</script>

<style scoped>
  .article-list-view {
    min-height: 100vh;
    background-color: #f8f9fa;
    padding: 20px 0;
  }

  .page-header {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
  }

  .page-title {
    color: #1e347d;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .breadcrumb {
    background: none;
    padding: 0;
    margin: 0;
  }

  .breadcrumb-item a {
    color: #ec621a;
    text-decoration: none;
  }

  .breadcrumb-item a:hover {
    text-decoration: underline;
  }

  .breadcrumb-item.active {
    color: #6c757d;
  }

  @media (max-width: 768px) {
    .page-title {
      font-size: 2rem;
    }

    .page-header {
      padding: 15px;
    }
  }
</style>
